export const TYPE_SOCIAL_MEDIA_LEAD = 'socialMediaLead';
